<template>
	<quick-links v-model="list"></quick-links>
</template>
<script>
	import { ref, inject } from "vue";
	import quickLinks from "@/components/webComponents/widget/quickLinks/quickLinks.vue";

	export default {
		components: {
			quickLinks
		},
		props: {
			items: {
				type: String,
				default: "[]"
			}
		},
		setup(props, context) {
			const $json = inject("$json");

			const list = ref([]);

			if ($json.packed(props.items)) {
				list.value = JSON.parse($json.unpack(props.items));
			} else {
				list.value = JSON.parse(props.items || "[]");
			}

			return {
				list
			};
		}
	};
</script>